import {createStyles, Theme} from "@material-ui/core";
import {alpha} from "@material-ui/core/styles";
import {styleColors, typography} from "src/main.style";

export const ButtonStyle = (theme: Theme) => {
  const primaryOutlineColor = theme.palette.type === 'dark' ? theme.palette.primary.light : theme.palette.primary.main;
  return createStyles({
    root: {
        boxSizing: "border-box",
        textTransform: "none",
    },
    label: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1.25),
        textAlign: 'center',
    },
    text: {
        ...typography.button,
        fontWeight: 600,
    },
    textSizeSmall: {
        fontSize: '0.75rem',
        lineHeight: "normal",
        letterSpacing: '2px',
    },
    sizeLarge: {
        padding: theme.spacing(1.5, 3.5),
        minHeight: '60px',
    },
    sizeSmall: {
        padding: theme.spacing(1, 2.5),
        fontSize: '0.59375rem',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: '1px',
    },
    contained: {
        ...typography.button,
        borderRadius: "3.125rem",
        textTransform: 'uppercase',
        color: theme.palette.common.black,
    },
    containedSizeSmall: {
        fontSize: '0.59375rem',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: '1px',
    },
    containedPrimary: {
      /* contrastText is actual white in both modes — common.white flips
         to the card surface in dark mode, which would be invisible on
         the purple primary background. */
      color: theme.palette.primary.contrastText,
    },
    containedSecondary: {
        color: theme.palette.secondary.contrastText,
    },
    outlined: {
        ...typography.button,
        borderRadius: "3.125rem",
        textTransform: 'uppercase',
        backgroundColor: theme.palette.common.white,
        border: '1px solid',
        borderColor: theme.palette.common.black,
        color: theme.palette.common.black,
/*        '&:hover': {
            backgroundColor: theme.palette.common.white,
        } */
    },
    outlinedSizeSmall: {
        fontSize: '0.59375rem',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: '1px',
    },
    textPrimary: {
        color: primaryOutlineColor,
    },
    outlinedPrimary: {
        backgroundColor: styleColors.transparent,
        borderColor: primaryOutlineColor,
        color: primaryOutlineColor,
        '&:hover': {
            borderColor: primaryOutlineColor,
            // Keep the lighter label readable against the dark-mode hover tint.
            backgroundColor: alpha(primaryOutlineColor, theme.palette.type === 'dark' ? 0.04 : theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: styleColors.transparent,
            },
        },
    },
    outlinedSecondary: {
        backgroundColor: styleColors.transparent,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
    },
  });
};



// WEBPACK FOOTER //
// ./src/components/common/button/Button.style.ts